export const fetchTmxRecords = (tmxs) => {
  return {
    type: 'GET_TMXS',
	tmxs: tmxs
  }
};
